import React from "react";

interface StatPillProps {
  value: number;              // supports 0
  label: string;              // e.g. "Points" or "Coins"
  valueClassName?: string;    // e.g. "text-emerald-700" vs "text-yellow-500"
}

const StatPill: React.FC<StatPillProps> = ({
  value,
  label,
  valueClassName = "text-emerald-700",
}) => {
  return (
    <div className="flex flex-col items-end leading-tight">
      <span className={`text-lg font-semibold ${valueClassName}`}>
        {value}
      </span>
      <span className="text-xs text-gray-600">{label}</span>
    </div>
  );
};

export default StatPill;
